import { gsap } from 'gsap'

/* Single entry point for gsap so every section shares one instance and one set
 * of defaults. Registered plugins would go here. */
gsap.defaults({ ease: 'power3.out' })

export { gsap }
